import type { ITaskSheetBody, ITaskSheetSection } from '@/interfaces'
import { TaskSheetSection } from '../task-sheets'

class TaskSheetBody implements ITaskSheetBody {
  id?: string

  title: string

  rows: ITaskSheetSection[]

  constructor(taskSheetConfigurableBodyUpdate?: any) {
    this.id = taskSheetConfigurableBodyUpdate?.id
    this.title = taskSheetConfigurableBodyUpdate?.title
    this.rows = taskSheetConfigurableBodyUpdate?.rows
      ? taskSheetConfigurableBodyUpdate?.rows.map(
          (row: ITaskSheetSection) => new TaskSheetSection(row)
        )
      : [new TaskSheetSection(taskSheetConfigurableBodyUpdate)]
  }
}

export default TaskSheetBody
